import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable array-callback-return */
/* eslint-disable no-prototype-builtins */
// import styles from './index.module.scss';
import { CnStep, CnStepItem } from '@cainiaofe/cn-ui';
export default function DWSteps(props) {
    const { data, shape = 'circle', onClick = (index) => {
        return index;
    }, } = props;
    const result = (_jsx("div", { children: _jsx(CnStep, { shape: shape, children: data.map((item) => {
                return (_jsx(CnStepItem, { title: item.title, status: item.status, content: item.content, onClick: onClick, animation: true }));
            }) }) }));
    return result;
}
DWSteps.displayName = 'DWSteps';
export { DWSteps };
